export default "__VITE_ASSET__jTEgnY1a__"